<template>
    <div>
        <v-dialog v-model="dialog_select_address" no-click-animation persistent scrollable lazy content-class="full-height" max-width="400" height="400" transition="dialog-bottom-transition">
            <v-card flat>
                <v-toolbar flat fixed>
                  <v-btn icon @click="closeDialogWeb"><v-icon>close</v-icon></v-btn>
                  <v-toolbar-title>Shipping Address</v-toolbar-title>
                  <v-spacer></v-spacer>
                  <!-- <v-btn icon small @click="fn_doneSelection" class="mr-2">Done</v-btn> -->
                  <v-btn icon small color="primary" @click="$parent.fn_addNewAddress(102, 'multi')" class="mr-2">New</v-btn>
                </v-toolbar>


                <v-card-text full-height id="scrollable-div" style="padding:0">

                    <div v-for="(address, index) in addresses" :key="index" class="dark-opacity-color">
                        <template v-if="address.groupTypeId == 102">
                            <v-layout pt-2 pb-2 wrap white-background @click="fn_selectAddress(address)">
                                <v-flex xs10 sm10 md10 pl-3>
                                    <div>{{$parent.fn_mergeAddress(address)}}</div>
                                </v-flex>
                                <v-flex xs2 sm2 md2 right-align pr-3>
                                    <v-icon>keyboard_arrow_right</v-icon>
                                    <!-- <v-icon v-else>radio_button_unchecked</v-icon> -->
                                </v-flex>
                            </v-layout>
                            <v-divider v-if="addresses.length-1 != index"></v-divider>
                        </template>
                    </div>
                    
                </v-card-text>

            </v-card>
          </v-dialog>

    
    </div>
</template>

<script>

export default{
    data(){
        return{
            dialog_select_address: false,
            addresses:[]
        }
    },
    methods:{
        openDialogWeb: function () {
            this.dialog_select_address = true;
            this.addresses = JSON.parse(JSON.stringify(this.$parent.Form.partyDetails.addresses));
        },
        closeDialogWeb: function () {
            this.dialog_select_address = false;
        },
        fn_selectAddress: function(addressObj){
            let itemIndex = this.addresses.findIndex(address=>{
                return addressObj.addressId == address.addressId;
            }) 
            for(let i=0; i<this.addresses.length; i++){
                if(this.addresses[i].groupTypeId == 102){
                    this.addresses[i].isDefault = false;
                }
            }
            this.addresses[itemIndex].isDefault = true;
            this.selectedItemIndex = itemIndex;
            this.fn_doneSelection();
        },
        fn_doneSelection: function(){
            for(let i=0; i<this.$parent.Form.partyDetails.addresses.length; i++){
                if(this.$parent.Form.partyDetails.addresses[i].groupTypeId == 102){
                    this.$parent.Form.partyDetails.addresses[i].isDefault = false;
                }                
            }
            this.$parent.Form.partyDetails.addresses[this.selectedItemIndex].isDefault = true;
            this.$parent.Form.addresses = this.$parent.Form.partyDetails.addresses.filter(address=>{
                return address.isDefault;
            })
            this.fn_closeDialog();
        },
        fn_closeDialog: function(){
            if(this.$parent.fn_closeDialog){
                this.$parent.fn_closeDialog();
            }
            else{
                this.closeDialogWeb();
            }
        }
    }
}
</script>